import {Field} from 'formik'
import {Table} from 'src/feature/bite/component'
import {useGetCampaignProductsAll} from '../../context/useQuery'
import {useSearchParams} from 'react-router-dom'
import {useReferral} from '../../hook'
import {useIntl} from 'react-intl'

type Props = {
  setSection: any
  handleBack: any
  allProducts: any
  paging: any
  pagingSet: any
}

const SelectProducts = (props: Props) => {
  const intl = useIntl()
  const [params] = useSearchParams()
  const {selectedCampaignProduct, selectedCampaignProductSet} = useReferral()

  const {isLoading} = useGetCampaignProductsAll({
    campaignId: params.get('campaignId') || '',
  })

  const Columns = [
    {
      title: '',
      key: 'id',
      dataIndex: 'id',
      render: (id: any, record: any) => {
        return (
          <div className='d-flex align-items-center gap-2'>
            <Field
              type='checkbox'
              name='products'
              value={id}
              className='form-check-input'
              checked={selectedCampaignProduct?.some((item: any) => item.id === id)}
              onChange={(e: any) => {
                const {checked} = e.target
                if (checked) {
                  selectedCampaignProductSet([...selectedCampaignProduct, record])
                } else {
                  selectedCampaignProductSet(
                    selectedCampaignProduct.filter((item: any) => item.id !== id)
                  )
                }
              }}
            />
          </div>
        )
      },
    },
    {
      title: intl.formatMessage({id: 'GLOBAL.PRODUCT.CODE'}),
      key: 'code',
      dataIndex: 'code',
    },
    {
      title: intl.formatMessage({id: 'GLOBAL.PRODUCT.NAME'}),
      key: 'name',
      dataIndex: 'name',
    },
    {
      title: intl.formatMessage({id: 'GLOBAL.PRODUCT.CATEGORY'}),
      key: 'category',
      dataIndex: 'category',
    },
  ]

  return (
    <>
      {/* <div className='p-5 d-flex justify-content-between'>
        <button
          className='btn btn-primary'
          onClick={() => {
            props.handleBack()
            props.setSection(1)
          }}
        >
          <span className='d-flex align-items-center gap-2'>
            <i className='bi bi-arrow-left'></i>
            <span>{intl.formatMessage({id: 'GLOBAL.BACK'})}</span>
          </span>
        </button>
      </div> */}
      <div className='p-5'>
        <Table
          loading={isLoading}
          dataSource={props.allProducts}
          columns={Columns}
          pagination={{
            current: props.paging.currentPageNumber,
            pageSize: props.paging.pageSize,
            total: props.paging.totalCount,
            onChange: (pagination: {current: number; pageSize: number; total: number}) => {
              if (!props || !props.allProducts) return

              const {pageSize, current} = pagination
              const currentPage = pageSize !== props.paging.pageSize ? 1 : current

              props.pagingSet({
                ...props.paging,
                currentPageNumber: currentPage,
                pageSize: pageSize,
              })
            },
          }}
        />
      </div>
      <div className='p-5 d-flex justify-content-end'>
        <button
          className='btn btn-primary'
          onClick={() => {
            props.handleBack()
            props.setSection(1)
          }}
        >
          <span className='d-flex align-items-center gap-2'>
            {/* <i className='bi bi-arrow-left'></i> */}
            <span>{intl.formatMessage({id: 'GLOBAL.ADD'})}</span>
          </span>
        </button>
      </div>
    </>
  )
}

export default SelectProducts
